export function shuffleArray( ary ) {
    for ( let i = ary.length - 1; i > 0; i-- ) {
        const j = Math.floor( Math.random() * ( i + 1 ));
        const tmp = ary[i];
        ary[i] = ary[j];
        ary[j] = tmp;
    }

    return ary
}